'use client'

import { createComponent } from '@lit/react'
import { PktModal as PktElModal } from '@oslokommune/punkt-elements'
// eslint-disable-next-line no-restricted-syntax -- React is required for createComponent
import React, { FC, ForwardedRef, forwardRef, type ReactElement } from 'react'

import type { PktElConstructor,PktElType } from '@/interfaces/IPktElements'

export interface IPktModal extends PktElType {
  headingText?: string
  hideCloseButton?: boolean
  closeOnBackdropClick?: boolean
  size?: 'small' | 'medium' | 'large'
  removePadding?: boolean
  closeButtonSkin?: 'blue' | 'yellow-filled'
  variant?: 'dialog' | 'drawer'
  drawerPosition?: 'left' | 'right'
  transparentBackdrop?: boolean
}
const LitComponent: FC<IPktModal> = createComponent({
  tagName: 'pkt-modal',
  elementClass: PktElModal as PktElConstructor<HTMLElement>,
  react: React,
  displayName: 'PktModal',
  events: {},
})

export const PktModal: FC<IPktModal> = forwardRef(
  ({ children, ...props }: IPktModal, ref: ForwardedRef<HTMLElement>): ReactElement => {
    return (
      <LitComponent {...props} ref={ref}>
        <div className="pkt-contents">{children}</div>
      </LitComponent>
    )
  },
)

PktModal.displayName = 'PktModal'
